import AuthenticatedLayout from '../../components/AuthenticatedLayout'
import { Link, router } from '@inertiajs/react'

function formatCurrency(amount) {
  return new Intl.NumberFormat('sv-SE', { style: 'currency', currency: 'SEK' }).format(amount || 0)
}

function formatDate(isoString) {
  return new Date(isoString).toLocaleDateString('sv-SE')
}

export default function Orders({ store, orders, can_mark_paid }) {
  function markAsPaid(orderId) {
    router.patch(`/stores/${store.id}/orders/${orderId}`)
  }

  return (
    <AuthenticatedLayout>
      <div className="space-y-6">
        <Link href="/dashboard" className="text-sm text-indigo-600 hover:underline">
          ← Tillbaka till startsidan
        </Link>

        <h1 className="text-2xl font-bold text-gray-900">
          {store.user_name} · {store.activity_name}
        </h1>

        <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
          {orders.length === 0 ? (
            <p className="px-4 py-8 text-center text-gray-500 text-sm">Inga beställningar ännu.</p>
          ) : (
            <table className="w-full text-left">
              <thead className="bg-gray-50 text-xs text-gray-500 uppercase tracking-wide">
                <tr>
                  <th className="px-4 py-3">Datum</th>
                  <th className="px-4 py-3">Kund</th>
                  <th className="px-4 py-3">Artiklar</th>
                  <th className="px-4 py-3">Totalt</th>
                  <th className="px-4 py-3">Status</th>
                  <th className="px-4 py-3"></th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {orders.map(order => (
                  <tr
                    key={order.id}
                    onClick={() => router.visit(`/stores/${store.id}/orders/${order.id}`)}
                    className="hover:bg-indigo-50 cursor-pointer"
                  >
                    <td className="px-4 py-3 text-sm text-gray-500 whitespace-nowrap">
                      {formatDate(order.created_at)}
                    </td>
                    <td className="px-4 py-3 text-sm">
                      <div className="text-gray-900">{order.customer_name}</div>
                      <div className="text-gray-500">{order.customer_email}</div>
                    </td>
                    <td className="px-4 py-3 text-sm text-gray-500">
                      {order.items.map(item => `${item.name} ×${item.quantity}`).join(', ')}
                    </td>
                    <td className="px-4 py-3 text-sm font-medium text-gray-900 whitespace-nowrap">
                      {formatCurrency(order.total)}
                    </td>
                    <td className="px-4 py-3 text-sm whitespace-nowrap">
                      {order.status === 'paid' ? (
                        <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800">
                          Betald
                        </span>
                      ) : can_mark_paid ? (
                        <button
                          onClick={e => { e.stopPropagation(); markAsPaid(order.id) }}
                          className="text-indigo-600 hover:underline"
                        >
                          Markera som betald
                        </button>
                      ) : (
                        <span className="text-gray-400">Ej betald</span>
                      )}
                    </td>
                    <td className="px-4 py-3 text-gray-400">
                      <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                      </svg>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </AuthenticatedLayout>
  )
}
